<div class="banner-wrapper  home banner_home__Vtt9b" style="background-image: url('https://marketplace.nvidia.com/assets/images/banner/home/nvidia-marketplace-bb300-l.jpg');">
   <div class="banner_banner-content__nXqXz container"> 
      <div class="breadcrumb_container">
      <nav aria-label="breadcrumb" class="breadcrumb-wrapper" *ngIf="primaryBreadcrumb">
         <ol class=" breadcrumb breadcrumb_dark__K3Cvh">
           <li class="breadcrumb-item "><a href="/en-us/">Marketplace</a></li>
           <li *ngIf="secondaryBreadcrumb" class="breadcrumb-item active">{{ secondaryBreadcrumb  | translate }} </li>
         </ol>
       </nav></div>
       <div style="width: 950px;" class="">
          <div class="banner_col-md-8__14wka col-md-6 col-xs-12 col-sm-10">

            <h1  
            class="banner_banner-heading__c3iMj" kuiText
              style="padding-bottom: 10px !important; line-height: 1em"
              [class.hide-shop-geforce-graphics-cards-header]="showFilterCol">
              <span *ngIf="primaryBreadcrumb && secondaryBreadcrumb" class="">{{ secondaryBreadcrumb | translate }}</span>
              <span *ngIf="!(primaryBreadcrumb && secondaryBreadcrumb)" class="">{{ "header_text" | translate }}</span>
                    
              <!-- <span *ngIf="secondaryBreadcrumb" class="nv-subHeaderText">{{ (secondaryBreadcrumb + "_subheader_text") | translate }}</span>
              <span *ngIf="!secondaryBreadcrumb" class="nv-subHeaderText">{{ "subheader_text" | translate }}</span> -->
            </h1>
            <p class="banner_subHeading__UHh16 "><span class="nv-subHeaderText">{{ "subheader_text" | translate }}</span></p>

             
          </div>
       </div>
    </div>
 </div>